import React from 'react';
import { BaseCrud, FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { LookupField } from 'react/components/fields';
import { getResourceTo } from 'react/utils/utils';

function PaymentMethodAllowedCrud(props) {
  return (
    <BaseCrud updateMethod="PATCH" tabName="PaymentMethodAllowed.title" {...props}>
      <FormSection title={getResourceTo('generalInformation.section.title')}>
        <FormSectionColumn>
          <LookupField
            label="PaymentMethodAllowed.fields.from"
            name="paymentMethodFrom"
            lookupEntity="PaymentMethod"
            lookupEntityColumn="description"
            required
          />
          <LookupField
            label="PaymentMethodAllowed.fields.to"
            name="paymentMethodTo"
            lookupEntity="PaymentMethod"
            lookupEntityColumn="description"
            required
          />
        </FormSectionColumn>
      </FormSection>
    </BaseCrud>
  );
}

export default PaymentMethodAllowedCrud;
